<template>
  <div class="coupon">
    <van-sticky>
      <van-nav-bar title="领劵中心" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-pull-refresh
      v-model="refreshing"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <div
          class="coupon_list"
          v-for="(item, index) in couponList"
          :key="index"
        >
          <div class="list_item">
            <div class="item">
              <div class="item_name line2">
                {{ item.name }}
              </div>
              <!-- <span>{{ item.coupon_category_name }}</span> -->
            </div>
            <div>
              满{{ item.price_full }}元使用 剩余可领取<span style="color: #ff6d58">{{
                item.issuedQuantity - item.receivedQuantity
              }}</span
              >张
            </div>
            <div>有效期{{ item.beginDate }}至{{ item.endDate }}</div>
          </div>
          <div class="list_price">
            <div class="price">
              <span>￥</span>
              <div>{{ item.price_reduce }}</div>
            </div>
            <span @click="couponCollectSave(item.id)">领券</span>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Button, Icon, Image, Tag, List, PullRefresh, Notify } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      params: {
        keyword: "",
        page: 1,
        size: 8,
      },
      //优惠券列表
      couponList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
    };
  },

  created() {
    // 优惠券管理-列表
    this.getCouponList();
  },

  methods: {
    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        // 优惠券管理-列表
        that.getCouponList();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        that.getCouponList();
      }, 1000);
    },

    // 优惠券管理-列表
    getCouponList() {
      var that = this;
      that.$api
        .couponListAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.couponList = res.data.dataList;
            } else {
              that.couponList = [...that.couponList, ...res.data.dataList];
            }
            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //优惠券-领券
    couponCollectSave(id) {
      var that = this;
      that.$api
        .couponCollectSaveAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            Notify({
              type: "success",
              message: "已经领取成功，可以进领取中心进行查看",
              onClose() {
                that.params = {
                  keyword: "",
                  page: 1,
                  size: 8,
                };
                // 优惠券管理-列表
                that.getCouponList();
              },
            });
          } else {
            Notify({
              type: "warning",
              message: res.data.message,
              onClose() {
                that.params = {
                  keyword: "",
                  page: 1,
                  size: 8,
                };
                // 优惠券管理-列表
                that.getCouponList();
              },
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    onsubmit() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.coupon {
  .coupon_list {
    margin: auto;
    background-image: url("/static/images/coupon.jpg");
    background-size: 100%; /*设置图片大小*/
    background-repeat: no-repeat;
    width: 90%;
    height: 124px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .list_item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 70%;
      width: 200px;
      margin-left: 20px;
      font-size: 13px;
      color: #999;

      .item {
        display: flex;
        justify-content: space-between;
        font-size: 15px;
        font-weight: bold;
        color: #000;
        .item_name {
          width: 115px;
        }

        span {
          color: #ff6d58;
        }
      }
    }

    .list_price {
      display: flex;
      flex-direction: column;
      width: 100px;
      border-left: 1px dashed #f1f2f7;
      align-items: center;
      justify-content: center;
      height: 100%;

      .price {
        display: flex;
        align-items: flex-end;
        font-size: 25px;
        color: #ff6d58;
        font-weight: bold;

        span {
          font-size: 12px;
        }
      }

      > span {
        font-size: 12px;
        background: #ff6d58;
        padding: 4px 10px;
        color: #fff;
        border-radius: 5px;
        margin-top: 8px;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/personal/coupon.vue